<div class="table-renderer-container">
  <mode-flat-table-ng
    [token]="token"
    [isBuilder]="isBuilder"
    [isReport]="isReport"
    [isPhantom]="isPhantom"
    [domLayout]="domLayout"
    [columns]="columns"
    [content]="content"
    [paging]="paging"
    [format]="format"
    [fieldFormats]="resolvedFieldFormatMap"
    [encoding]="encoding"
    [dataProfiling]="dataProfiling"
    [conditionalFormatting]="conditionalFormatting"
    [hideColumnsCount]="true"
    [customConfig]="customConfig"
    [showColumnMenu]="showColumnMenu"
    [showFormatMenuOption]="isDesigner && !isViewPage"
    [showFilterMenuOption]="isDesigner && !isViewPage && showFilterMenuOption"
    [showRemoveMenuOption]="showRemoveMenuOption"
    [expandableCellContents]="true"
    [resizableColumns]="!isBuilder"
    [columnSearchEnabled]="false"
    [activeTableColumn]="activeTableColumn"
    [allowCustomPageSize]="isDesigner"
    [showConditionalFormattingMenuOption]="isDesigner && !isViewPage"
    [conditionalFormattingEnabled]="true"
    (offsetChange)="handleOffsetChange($event)"
    (columnWidthChange)="handleColumnWidthChange($event)"
    (fieldFormatEdit)="handleFieldFormatEdit($event)"
    (tableColumnSearchChange)="handleTableColumnSearchChange($event)"
    (sortChange)="updateSort($event)"
    (sortSettingsChange)="handleSortSettingsChange($event)"
    (sortClear)="handleSortClear($event)"
    (fieldRemoval)="handleFieldRemoval($event)"
    (filterFieldChange)="handleFilterFieldChange($event)"
    (columnSelectionChange)="handleColumnSelectionChange($event)"
    (setTableHeight)="handleSetTableHeight()"
    (renderStart)="start()"
    (renderEnd)="end()"
    (getDataProfiling)="handleGetDataProfiling($event)"
    (changePageSize)="handlePageSizeChange($event)"
    (conditionalFormattingApply)="handleConditionalFormatting($event)"
  ></mode-flat-table-ng>
</div>
